import React, { SVGProps } from 'react';

const ContractExpiryIcon = (props: SVGProps<SVGSVGElement>) => {
  const { className } = props;
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="54"
      height="54"
      viewBox="0 0 54 54"
      data-palette="ContractExpiryIcon">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0L64 0 64 64 0 64z" transform="translate(-5 -5)" />
        <path
          fill="var(--highlight)"
          fillRule="nonzero"
          d="M32 58.667C17.272 58.667 5.333 46.728 5.333 32 5.333 17.272 17.272 5.333 32 5.333c14.728 0 26.667 11.939 26.667 26.667 0 14.728-11.939 26.667-26.667 26.667zm-.002-3.004c13.07 0 23.665-10.595 23.665-23.665 0-13.07-10.595-23.665-23.665-23.665-13.07 0-23.665 10.596-23.665 23.665 0 13.07 10.596 23.665 23.665 23.665zM29.333 40h5.334v5.333h-5.334V40zm0-21.333h5.334v16h-5.334v-16z"
          transform="translate(-5 -5)"
        />
      </g>
    </svg>)
  );
};

export default ContractExpiryIcon;
